import { Link } from 'react-router-dom';
import { t } from 'i18next';
import RoundedCard from './RoundedCard';

const HelpCard = ({ locale }: { locale: string }) => {
  const helpCardMenu = [
    {
      title: 'myPage.myPageMenuItem.settings',
      description: 'myPage.myPageMenuItem.settingsDescription',
      path: '/account/manage'
    },
    {
      title: 'myPage.myPageMenuItem.report',
      description: 'myPage.myPageMenuItem.reportDescription',
      path: '/trading_reports'
    },
    {
      title: 'myPage.myPageMenuItem.contact',
      description: 'myPage.myPageMenuItem.contactDescription',
      path: `https://fanhearts.com/faq/?locale=${locale}`
    }
  ];

  return (
    <RoundedCard>
      <div className="px-[20px] py-[12px]">
        {helpCardMenu.map((item, index) => (
          <Link
            key={item.title}
            className={`py-[14px] flex ${
              index !== helpCardMenu.length - 1
                ? 'shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.04)] dark:shadow-[inset_0_-1px_0_0_rgba(255,255,255,0.06)]'
                : ''
            }`}
            to={item.path}
          >
            <div className="flex gap-[8px] h-[16px] items-center justify-start">
              <p className="text-text-main-lv3 text-[13px] font-medium">{t(item.title)}</p>
              <p className="text-sub-light-1 dark:text-sub-dark-1 text-[12px]">
                {t(item.description)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </RoundedCard>
  );
};

export default HelpCard;
